import React from 'react'

import { SubMenu } from '@application/Types/HeaderTypes'

import { FixedColumnWrapper, SubMenuColumn, SubMenuColumnTitle, SubMenuItem, SubMenuItemLink } from './Nav.styled'

export const ThreeColumnSubMenu = ({
    id,
    leftColumnHeader,
    leftColumnLinks,
    centerColumnHeader,
    centerColumnLinks,
    rightColumnHeader,
    rightColumnLinks,
}: SubMenu): JSX.Element => {
    return (
        <FixedColumnWrapper>
            <SubMenuColumn>
                <SubMenuColumnTitle>{leftColumnHeader}</SubMenuColumnTitle>
                {leftColumnLinks?.map((link, index) => (
                    <SubMenuItem key={`${id}-${index}-${link.label}`}>
                        <SubMenuItemLink to={link.link}>{link.label}</SubMenuItemLink>
                    </SubMenuItem>
                ))}
            </SubMenuColumn>
            <SubMenuColumn>
                <SubMenuColumnTitle>{centerColumnHeader}</SubMenuColumnTitle>
                {centerColumnLinks?.map((link, index) => (
                    <SubMenuItem key={`${id}-${index}-${link.label}`}>
                        <SubMenuItemLink to={link.link}>{link.label}</SubMenuItemLink>
                    </SubMenuItem>
                ))}
            </SubMenuColumn>
            <SubMenuColumn>
                <SubMenuColumnTitle>{rightColumnHeader}</SubMenuColumnTitle>
                {rightColumnLinks?.map((link, index) => (
                    <SubMenuItem key={`${id}-${index}-${link.label}`}>
                        <SubMenuItemLink to={link.link}>{link.label}</SubMenuItemLink>
                    </SubMenuItem>
                ))}
            </SubMenuColumn>
        </FixedColumnWrapper>
    )
}
